<template>
  <Toggle
    v-model:pressed="toggleState"
    @update:pressed="() => $emit('update', { is_private: toggleState })"
    :disabled="readonly"
    :aria-label="$t('components.task_details.visbility.label')"
    data-id="task.visibility"
  >
    <Visibility
      :isPrivate="toggleState"
      :iconOnly="maxTablet"
      :size="maxTablet ? 'lg' : 'md'"
      :disabled="readonly"
    />
  </Toggle>
</template>

<script setup>
import { ref } from "vue";
import { Toggle } from "radix-vue";
import { Visibility } from "@/SharedComponents/Badges";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxTablet } = useBreakpoints();

defineEmits(["update"]);

const props = defineProps({
  task: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
});

const toggleState = ref(!!props.task.problem?.is_private);
</script>
